import { createSlide } from '@/modules/createSlide';
import { navigateMediaItem } from '@/helpers/navigateMediaItem';
import { getSwiperInstance } from '@/helpers/swiperInstance';
import { groupMoveButton } from '@/modules/parts/desktop/groupMoveButton';
import { reelHeaderInitializing } from '@/helpers/reelHeaderInitializing';
import { activeVideoPlay } from "@/modules/actions/videoControls";
import { checkVolumeButtonState } from "@/helpers/volumeControl";
import { ctaButton } from '@/modules/parts/ctaButton';
import { clickCtaAction } from '@/modules/actions/clickCtaAction';
import { setupAutoPlayNextAction } from '@/modules/actions/desktop/setupAutoPlayNextAction';
import { slideClickNavigateAction } from "@/modules/actions/desktop/slideClickNavigateAction";
import { animateCurrentProgressBar } from "@/modules/actions/headerLineDuration";
import { applySlideScaling } from '@/modules/actions/slideScaleAction';
import { trackStoreeelEvent } from "@/helpers/trackStoreeelEvent";
import localStorageRepositories from "@/plugins/localStorageRepositories";

// ─── ボタンの描画だけを行う関数 ─────────────────────────
export const renderGroupMoveButtons = () => {
  const modal = document.querySelector('.storeeel-modal');
  // 既存のボタンをクリア
  modal.querySelectorAll('.leftGroupButtonFrame, .rightGroupButtonFrame').forEach(el => el.remove());
  // 新しいボタンを挿入
  modal.insertAdjacentHTML('beforeend', groupMoveButton());
};

// ─── イベントバインドだけを行う関数 ───────────────────────
export const bindGroupMoveButtonEvents = (changeGroupFn) => {
  const prevBtn = document.querySelector('.leftGroupButtonFrame');
  const nextBtn = document.querySelector('.rightGroupButtonFrame');
  if (prevBtn) prevBtn.addEventListener('click', () => changeGroupFn('prev'));
  if (nextBtn) nextBtn.addEventListener('click', () => changeGroupFn('next'));
};

// ─── グループ移動アクション全体 ──────────────────────────
export const groupMoveButtonAction = () => {
  const swiper   = getSwiperInstance();
  const wrapper  = document.querySelector('.storeeel-swiper-group-wrapper .swiper-wrapper');

  // 実際にグループを切り替える処理
  const changeGroup = (direction) => {
    const groupItem = direction === 'prev' ? window.prevGroup : window.nextGroup;
    window.iconId = groupItem.id;
    window.moviePosition = 0;

    const contents = navigateMediaItem();
    // 動画リストを再描画
    wrapper.innerHTML = '';
    contents.forEach(content => wrapper.appendChild(createSlide(content)));

    swiper.update();
    swiper.slideTo(0);
    // スライド再描画後に縮尺を適用
    applySlideScaling();

    // 初期グループ名取得＆バナー初期化
    const groupName = contents[0]?.group_name || '';
    reelHeaderInitializing(contents.length, groupName);

    // ボタン再描画＋再バインド
    renderGroupMoveButtons();
    bindGroupMoveButtonEvents(changeGroup);

    // スライドの動画再生
    activeVideoPlay();

    // 音量状態を確認し、activeなスライドの音量を変更
    checkVolumeButtonState();

    // CTAボタンの再描写
    const allWrappers = document.querySelectorAll('.storeeel-swiper-group-wrapper .swiper-slide .slide-media-wrapper');
    allWrappers.forEach((wrapper, index) => {
      const ctaText = contents[index]?.ctaText || '';
      wrapper.insertAdjacentHTML('beforeend', ctaButton(ctaText));
    });
    clickCtaAction();

    // 動画の再生が終わったら次のスライドへ
    setupAutoPlayNextAction();

    // スライドクリックで該当スライドに移動する処理を追加
    slideClickNavigateAction();

    // 進捗バーのアニメーションを開始
    const video = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper video');
    if (video) {
      video.addEventListener('loadedmetadata', () => {
        animateCurrentProgressBar(video.duration, 0);
      });
    }
    const image = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper img');
    if (image) {
      image.addEventListener('load', () => {
        animateCurrentProgressBar(5, 0);
      });
    }

    // 計測とローカルストレージ保存
    let mediaName;
    let mediaId;
    let groupId;
    if (video) {
      mediaName = video.getAttribute('media-name');
      mediaId = video.getAttribute('media-id');
    } else if (image) {
      mediaName = image.getAttribute('media-name');
      mediaId = image.getAttribute('media-id');
    }
    if (window.storeeelItems.frame === "circle") {
      groupId = window.iconId
    } else {
      groupId = null
    }
    trackStoreeelEvent('storeeel_media_asset_view', {
      'storeeel_name':  mediaName,
      'group_id':       groupId,
      'media_id':       mediaId,
      'campaign_id':    window.storeeelItems.id,
    });
    localStorageRepositories.get("mediaView").set(
      mediaId,
      window.storeeelItems.id
    );
  };

  // 初回描画＋バインド
  renderGroupMoveButtons();
  bindGroupMoveButtonEvents(changeGroup);
  // 初回描画後とスライド移動時に縮尺を当てる
  applySlideScaling();
  swiper.on('slideChange', applySlideScaling);
};
